export const STATUS_COLOR = {
    active: '#0053AD',
    inactive: '#CB002B',
    other: '#44494D'
}